export const RoleBadgeType = Object.freeze({
  OLD: 'old',
  ADDED: 'added',
  REMOVED: 'removed',
  NEW: 'new',
});

const roleColumnStyles = [
  { type: RoleBadgeType.OLD, bg: '#FEF9C3', color: '#854D0E', border: '#FDE047' },
  { type: RoleBadgeType.ADDED, bg: '#DCFCE7', color: '#166534', border: '#86EFAC' },
  { type: RoleBadgeType.REMOVED, bg: '#FEE2E2', color: '#991B1B', border: '#FCA5A5' },
  { type: RoleBadgeType.NEW, bg: '#DBEAFE', color: '#1E40AF', border: '#93C5FD' },
];

const parseJsonArray = (value) => {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) && parsed.length ? parsed : [];
  } catch {
    return [];
  }
};

export default function RoleBadges({ value, type }) {
  const roles = parseJsonArray(value);
  const style = roleColumnStyles.find((entry) => entry.type === type);

  if (!roles.length) return <span style={{ color: '#9CA3AF' }}>—</span>;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
      {roles.map((role, i) => (
        <span
          key={i}
          style={{
            display: 'inline-block',
            padding: '2px 8px',
            borderRadius: '9999px',
            fontSize: '12px',
            fontWeight: 500,
            backgroundColor: style.bg,
            color: style.color,
            border: `1px solid ${style.border}`,
            whiteSpace: 'nowrap',
          }}
        >
          {role}
        </span>
      ))}
    </div>
  );
}
